// extracted by mini-css-extract-plugin
export default {"langaugeForm":"ChangeExploreLanguages_langaugeForm__VEb07"};